import {ServerUrl, xhr} from "../functions";

export function getCategoryInfo(category_id, rootsChain = false) {
    return new Promise((res, rej) => {
        xhr(`api/admin/contents/categories/${category_id}`, 'GET', {
            roots_chain: rootsChain ? 1 : 0
        }).then(r => {
            res(r.data);
        }).catch((r) => {
            rej(r);
        })
    })
}

export const EditorMixin = {
    methods: {
        tinyMCEInit(id, fileUploadCallback = undefined, setupEditor = undefined) {
            return this.tinyMCEInitConfig(id, {}, fileUploadCallback, setupEditor);
        },
        tinyMCEInitConfig(id, config = {}, fileUploadCallback = undefined, setupEditor = undefined) {
            window.tinymce.remove(`#${id}`);
            return window.tinymce.init({
                selector: `#${id}`,
                toolbar_mode: 'sliding',
                directionality: 'rtl',

                plugins: ['directionality', 'image', 'fullscreen', 'link', 'lists', 'advlist',
                    'media', 'anchor', 'code', 'table', 'wordcount'],
                toolbar: [
                    'h1 h2 h3 h4 h5 h6 |',
                    'undo redo | styleselect | strong bold italic | alignleft aligncenter alignright alignjustify | outdent indent | rtl ltr ' +
                    ' numlist bullist | ' +
                    ' | filemanagerToolbarButton mhr_clear_fonts mhr_clear_style mhr_convert_strong_to_bold | media ' +
                    ' link anchor fullscreen | code | wordcount'],
                table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                contextmenu: 'link linkchecker image imagetools table spellchecker configurepermanentpen | custom-h1 custom-h2 custom-h3 custom-h5 custom-h6 custom-p',
                rel_list: [
                    {title: 'None', value: ''},
                    {title: 'No Referrer', value: 'noreferrer'},
                    {title: 'No Follow', value: 'nofollow'},
                    {title: 'External Link', value: 'external'}
                ],

                font_formats: 'Default=inherit,Cario=cario;IranSanse=iransans;Cairo-SemiBold=carioSemiBold',
                content_css: [ServerUrl('/templateAssets/styles/fonts/fonts.css')],
                content_style: 'body{font-family : shabnam; } ul,ol{margin: 10px} q,blockquote {padding: .5rem; background: #eee; cursor:pointer;}',
                min_height: 300,
                fontsize_formats: [
                    '8pt', '10pt', '12pt', '14pt', '16pt', '18pt', '20pt', '22pt',
                    '24pt', '26pt', '28pt', '30pt', '32pt', '34pt', '36pt', '38pt'
                ].join(' '),
                image_caption: true,

                convert_urls: false,
                relative_urls: false,
                remove_script_host: false,

                formats: {
                    bold: [
                        {inline: 'b', remove: 'all'}
                    ],
                    strong: [
                        {inline: 'strong', remove: 'all'}
                    ],
                },
                style_formats: [
                    {
                        title: 'Headings', items: [
                            {title: 'Heading 1', format: 'h1'},
                            {title: 'Heading 2', format: 'h2'},
                            {title: 'Heading 3', format: 'h3'},
                            {title: 'Heading 4', format: 'h4'},
                            {title: 'Heading 5', format: 'h5'},
                            {title: 'Heading 6', format: 'h6'}
                        ]
                    },
                    {
                        title: 'Inline', items: [
                            {title: 'Strong', format: 'strong'},
                            {title: 'Bold', format: 'bold'},
                            {title: 'Italic', format: 'italic'},
                            {title: 'Underline', format: 'underline'},
                            {title: 'Strikethrough', format: 'strikethrough'},
                            {title: 'Superscript', format: 'superscript'},
                            {title: 'Subscript', format: 'subscript'},
                            {title: 'Code', format: 'code'}
                        ]
                    },
                    {
                        title: 'Blocks', items: [
                            {title: 'Paragraph', format: 'p'},
                            {title: 'Blockquote', format: 'blockquote'},
                            {title: 'Div', format: 'div'},
                            {title: 'Pre', format: 'pre'}
                        ]
                    },
                    {
                        title: 'Align', items: [
                            {title: 'Left', format: 'alignleft'},
                            {title: 'Center', format: 'aligncenter'},
                            {title: 'Right', format: 'alignright'},
                            {title: 'Justify', format: 'alignjustify'}
                        ]
                    }
                ],

                extended_valid_elements: 'b',


                setup: editor => {
                    editor.on('dblclick', e => {
                        const blockQuote = e.target.closest('blockquote,q');
                        if (blockQuote) {
                            const url = prompt("آدرس منبع را وارد کنید", blockQuote.getAttribute('cite') || '');
                            if (url)
                                blockQuote.setAttribute('cite', url);
                        }
                    })
                    if (fileUploadCallback) {
                        editor.ui.registry.addButton('filemanagerToolbarButton', {
                            text: 'file manager',
                            onAction: () => {
                                if (typeof fileUploadCallback === 'function')
                                    fileUploadCallback(editor);
                            }
                        })
                    }

                    editor.ui.registry.addButton('mhr_clear_fonts', {
                        text: 'Clear Font',
                        tooltip: 'حذف فونت های منبع و تنظیم شد از تمام محتوا (آزمایشی)',
                        onAction: () => {
                            editor.setContent(editor.getContent().replaceAll(/(font-family:[^;]+;|font-size:[^;]+;)/g, ''))
                        }
                    })
                    editor.ui.registry.addButton("mhr_clear_style", {
                        text: "Clear Styles",
                        tooltip: "حذف اتریبیوت استایل از تمام المنت ها (آزمایشی)",
                        onAction: () => {
                            if (confirm("این ویژگی به صورت آزمایشی ایجاد شده است و باعث حذف تمام ویژگی های style،class و dir از روی عناصر html خواهد شد.\nادامه میدهید؟")) {
                                editor.selection.setContent(editor.selection.getContent()
                                    .replaceAll(/(class|style|dir)=(['"]).*?\2/gi, "")
                                    .replaceAll(/\s*(?=>)/gi, ""));
                            }
                        }
                    });

                    editor.ui.registry.addButton('mhr_convert_strong_to_bold', {
                        text: 'strong => b',
                        tooltip: 'تبدیل تگ های strong به b',
                        onAction: () => {
                            editor.setContent(editor.getContent().replaceAll(/<(\/?)strong>/gi, '<$1b>'))
                        }
                    })
                    Object.entries({
                        h1: 'Heading 1',
                        h2: 'Heading 2',
                        h3: 'Heading 3',
                        h4: 'Heading 4',
                        h5: 'Heading 5',
                        h6: 'Heading 6',
                        p: 'Paragraph (normal text)'
                    }).forEach(([k, v]) => {
                        editor.ui.registry.addMenuItem(`custom-${k}`, {
                            text: v,
                            onAction() {
                                const node = editor.selection.getNode()
                                if (!node) return;
                                const element = editor.dom.create(k);
                                element.innerHTML = node.innerHTML;
                                editor.dom.replace(element, node);
                            }
                        });
                    })


                    if (setupEditor && typeof setupEditor === 'function') {
                        setupEditor(editor);
                    }
                },
                ...
                    config
            });
        },
        tinyMCEGetContent(id) {
            return window.tinymce.get(id).getContent();
        },
        tinyMCEGetEditor(id) {
            return window.tinymce.get(id);
        },
        tinyMCESetContent(id, content) {
            window.tinymce.get(id).setContent(content);
            window.tinymce.get(id).focus();
        },
        tinyMCEFocus(id) {
            window.tinymce.get(id).focus();
        },
        autoUploader(file, onProgress = undefined) {
            const fd = new FormData();
            fd.append('file', file);
            return xhr('api/admin/file-manager/auto-upload', 'post', fd, onProgress)
        },
        addContentTableToEditor(editor) {
            editor.ui.registry.addButton('mhr_add_content_table', {
                text: 'فهرست مطالب',
                onAction: () => {
                    //editor.insertContent('[content_table]')
                    const headers = editor.dom.doc.querySelectorAll('h1,h2');
                    if (headers && headers.length > 0) {
                        const contentTable = document.createElement('nav');
                        contentTable.classList.add('content-table-container');
                        contentTable.innerHTML += "<div class='header'>فهرست مطالب</div>"
                        const linksContainer = document.createElement('div');
                        linksContainer.classList.add('links-container');
                        contentTable.append(linksContainer);

                        headers.forEach(x => {
                            const element = document.createElement('a');
                            element.innerText = x.innerText;
                            if (!x.id)
                                x.id = x.innerText.trim().replaceAll(/[^\d\p{L}]+/gu, '-');
                            element.href = `#${x.id}`;
                            linksContainer.append(element)
                        });
                        editor.insertContent(contentTable.outerHTML)
                    }
                }
            });

            editor.contentStyles.push('.content-table-container{border:thin solid gray;} .content-table-container a {display:block; }');
            editor.settings.toolbar += ' | mhr_add_content_table';
        },
    }
}
